export const STATUS_LABEL = {
  trial: "Пробный",
  active: "Активен",
  suspended: "Отключён",
};

const DAY_MS = 24 * 60 * 60 * 1000;

export function formatRub(n) {
  return new Intl.NumberFormat("ru-RU").format(Number(n) || 0);
}

export function formatDateRu(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("ru-RU", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

export function formatDateTimeRu(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("ru-RU", {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatRelativeActivity(iso) {
  if (!iso) return "Нет активности";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const diff = Date.now() - d.getTime();
  if (diff < 0) return "Сейчас";
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "Только что";
  if (mins < 60) return `${mins} мин. назад`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours} ч. назад`;
  const days = Math.floor(hours / 24);
  if (days < 14) return `${days} дн. назад`;
  return formatDateRu(iso);
}

export function daysLeftLabel(days) {
  if (days == null) return "—";
  if (days < 0) return `${Math.abs(days)} дн. назад`;
  return `${days} дн.`;
}

export function clinicEffectiveStatus(clinic) {
  const billing = clinic?.billing;
  if (clinic?.status === "suspended" || billing?.status === "suspended") {
    return "suspended";
  }
  if (billing?.is_demo_expired) return "expired";
  if (billing?.is_paid && !billing?.is_trial) return "active";
  if (billing?.is_trial) return "trial";
  if (clinic?.status === "active" && billing?.is_paid) return "active";
  if (clinic?.status === "trial") return "trial";
  return clinic?.status || "trial";
}

export function clinicStatusLabel(clinic) {
  const billing = clinic?.billing;
  if (billing?.status_label) return billing.status_label;
  const effective = clinicEffectiveStatus(clinic);
  if (effective === "expired") return "Демо истекло";
  return STATUS_LABEL[effective] || STATUS_LABEL[clinic?.status] || clinic?.status || "—";
}

export function statusClass(status, billing) {
  // status arg kept for callers; prefer billing when present
  if (status === "suspended" || billing?.status === "suspended") {
    return "statusSuspended";
  }
  if (billing?.is_demo_expired || (billing?.days_left != null && billing.days_left < 0 && !billing?.is_paid)) {
    return "statusExpired";
  }
  if (billing?.is_paid && !billing?.is_trial) return "statusActive";
  if (billing?.is_trial) return "statusTrial";
  if (billing?.is_expiring_soon) return "statusTrial";
  if (status === "trial") return "statusTrial";
  if (status === "active") return "statusActive";
  return "statusNeutral";
}

export function activityTone(iso) {
  if (!iso) return "muted";
  const diff = Date.now() - new Date(iso).getTime();
  if (diff > 14 * DAY_MS) return "danger";
  if (diff > 7 * DAY_MS) return "warn";
  return "ok";
}

export function filterClinics(clinics, query) {
  const q = String(query || "").trim().toLowerCase();
  if (!q) return clinics;
  return clinics.filter((c) => {
    const owner = c.owner || {};
    const hay = [
      c.name,
      c.subdomain,
      c.plan?.name,
      c.billing?.plan_label,
      owner.full_name,
      owner.email,
      owner.phone,
      c.phone,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
    return hay.includes(q);
  });
}

export function summarizeClinics(clinics) {
  const list = clinics || [];
  const expiring14 = list.filter(
    (c) =>
      c.billing?.is_paid &&
      !c.billing?.is_trial &&
      c.billing?.days_left != null &&
      c.billing.days_left >= 0 &&
      c.billing.days_left <= 14,
  ).length;
  const inactive7d = list.filter((c) => {
    const at = c.activity?.last_activity_at;
    if (!at) return true;
    return Date.now() - new Date(at).getTime() > 7 * DAY_MS;
  }).length;
  return {
    total: list.length,
    active: list.filter((c) => clinicEffectiveStatus(c) === "active").length,
    trial: list.filter((c) => clinicEffectiveStatus(c) === "trial").length,
    suspended: list.filter((c) => clinicEffectiveStatus(c) === "suspended").length,
    expired: list.filter((c) => clinicEffectiveStatus(c) === "expired").length,
    expiring14,
    inactive7d,
    clients: list.reduce((sum, c) => sum + (c.stats?.clients || 0), 0),
    trainers: list.reduce((sum, c) => sum + (c.stats?.trainers || 0), 0),
  };
}
